import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import scrollToComponent from 'react-scroll-to-component';

import {ScheduleShoppingFormContainer} from './components/ScheduleShoppingForm';
import {ScheduleServiceFormContainer} from './components/ScheduleServiceForm';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class ScheduleAppointment extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
			selectedForm: null,
		}
	}

	componentWillMount() {
		document.title = 'Diamonds Direct - Schedule an Appointment';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	}

	componentDidMount() {
    // setTimeout(() => {
    // 	this.props.commonNotify();
    // }, 1000);
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  selectShop() {
    this.setState({ selectedForm: 'SHOP' }, () => {
      this.scrollDown();
    });
  }

  selectService() {
    this.setState({ selectedForm: 'SERVICE' }, () => {
      this.scrollDown();
    });
  }

  scrollDown() {
    scrollToComponent(this.formWrapper, {
      offset: -100, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  closeAllForms() {
    this.setState({ selectedForm: null });
    scrollToComponent(this.parentForm, {
      offset: -100, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

	render() {
		return <div className='ScheduleAppointment' ref={(div) => { this.parentForm = div; }}>
			<div className='scheduleHeader'>Request an Appointment</div>
			<div className='scheduleBody'>
        <div className='scheduleBr'></div>
        <div className={'sbText desktop600'}>Our promise to you is the very best diamond education, personal guidance, and customer service in the industry. Our appointment request feature is provided for your convenience; however, an appointment is not required for shopping&nbsp;or&nbsp;service.</div>
        <div className={'sbText mobile600'}>Our promise to you is the very best diamond education, personal guidance, and customer service in the industry. Our appointment request feature is provided for your convenience; however, an appointment is not required for shopping&nbsp;or&nbsp;service.</div>

        <div className='sbPrompt'>Select a Service</div>

        <div className='sbButtonRow' ref={(div) => { this.buttonRow = div; }}>
          <div className={this.state.selectedForm === 'SHOP' ? 'sbButton selected' : 'sbButton'} onClick={::this.selectShop}>
            <div className={'sbButtonIcon jewelryIcon'}></div>
            <div className='sbButtonLabel'>Shop&nbsp;In&nbsp;Store</div>
          </div>
          <div className={this.state.selectedForm === 'SERVICE' ? 'sbButton selected' : 'sbButton'} onClick={::this.selectService}>
            <div className={'sbButtonIcon bellIcon'}></div>
            <div className='sbButtonLabel'>Service&nbsp;and&nbsp;Repairs</div>
          </div>
        </div>
        <div className='sbFormWrapper' ref={(div) => { this.formWrapper = div; }}>
  				<div style={{display: this.state.selectedForm === 'SHOP' ? 'block' : 'none'}}>
  					<ScheduleShoppingFormContainer closeMethod={::this.closeAllForms} />
  				</div>
          <div style={{display: this.state.selectedForm === 'SERVICE' ? 'block' : 'none'}}>
            <ScheduleServiceFormContainer closeMethod={::this.closeAllForms} />
          </div>
        </div>
        <div className='sbText'>If you prefer to bypass the form, you can contact the store nearest you by <span className='inlineLink' onClick={() => this.internalNav('locations')}>clicking here</span> or contact us at <a href='tel:8008855050' className='inlineLink'>(800) 885-5050</a></div>
			</div>
      <div className='scheduleFooterSpacer'></div>
		</div>;
	}
}
export default ScheduleAppointment;

function mapStateToProps(state) {
  return {

  };
}

export const ScheduleAppointmentContainer = connect(
  mapStateToProps,
  allActionCreators
)(ScheduleAppointment);


// WEBPACK FOOTER //
// ./src/components/views/scheduleappointment/ScheduleAppointment.jsx